const isLiteralTrue = (value: string | undefined): boolean => value === "true";

export const featureConfig = Object.freeze({
  isMockDataEnabled: isLiteralTrue(import.meta.env.VITE_ENABLE_MOCK_DATA),
});
